import Accordion from './accordion/accordion.vue';

export default  {
    Accordion
};
